import React from "react";
import "./AboutValuesSection.css";

interface ValueItem {
  title: string;
  description: string;
}

interface AboutValuesSectionProps {
  tag: string; // e.g. "Values"
  icon?: React.ReactNode; // ✅ changed from string to ReactNode for FontAwesome JSX
  values: ValueItem[]; // Array of title + description pairs
}

const AboutValuesSection: React.FC<AboutValuesSectionProps> = ({
  tag,
  icon,
  values,
}) => {
  return (
    <section className="about-values-section">
      {/* Tag Header */}
      <div className="feature-tag">
        {icon && <span className="values-icon">{icon}</span>}
        <span className="values-label">{tag}</span>
      </div>

      {/* Values List */}
      <div className="values-list">
        {values.map((val, i) => (
          <div key={i} className="value-block">
            <h3
              className="feature-title"
              dangerouslySetInnerHTML={{ __html: val.title }}
            />
            <p
              className="value-description"
              dangerouslySetInnerHTML={{ __html: val.description }}
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default AboutValuesSection;
